var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"overflow-y-auto",attrs:{"elevation":"0"}},[_c('expressionbars',{ref:"expressionbarsref",attrs:{"data":_vm.data,"barAttributes":_vm.barAttributes,"svgAttributes":_vm.svgAttributes},on:{"barSelected":_vm.barSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }